<template>
  <div>
    <div class="border-dashboard" style="background-color: #f7f7f7; height: 100%">
      <div
        :style="$vuetify.display.mdAndUp ? 'font-size: 20px' : 'font-size: 18px'"
        class="pt-6 mx-6 pb-4 border-dashboard-bottom"
      >
        Additional resources
      </div>
      <div class="pt-6 pb-4 px-6 my-support-grid-gap">
        <v-btn
          depressed
          rounded
          class="ma-0 additional-resources-button text-body-2"
          color="white"
          v-for="resource in resources"
          :key="resource.name"
          :href="resource.link"
          target="_blank"
          @click="handleResourceClick(resource.name)"
        >
          {{ resource.name }}
        </v-btn>
      </div>
    </div>
  </div>
</template>

<script>
import { defineComponent } from 'vue';

import { DataLayerMixin } from '../../mixins/dataLayerMixin';
export default defineComponent({
  mixins: [DataLayerMixin],
  name: 'AdditionalResourcesCard',

  data() {
    return {
      resources: [
        { name: 'Online Study Hub', link: 'https://tutoring.asu.edu/online-study-hub' },
        { name: 'Tutoring', link: 'https://tutoring.asu.edu/' },
        { name: 'Counseling', link: 'https://currentstudent.asuonline.asu.edu/student-services/360-life-services/' },
        { name: 'Degree Planner', link: 'https://interactive-degree-planner.apps.asu.edu/' },
        { name: 'Applying to ASU', link: 'https://admissions.asu.edu/' },
        { name: 'FAQs', link: 'https://ulc.asu.edu/help-center/faqs/' }
      ]
    };
  },

  methods: {
    goToResource(link) {
      window.open(link, '_blank');
    },
    handleResourceClick(resourceName) {
      this.asuoDataLayerClick('accelerateDashboard', '9', { text: resourceName.toLowerCase() });
    }
  }
});
</script>

<style lang="scss" scoped>
.my-support-grid-gap {
  display: inline-flex;
  flex-wrap: wrap;
  gap: 12px;
}

.additional-resources-button {
  border: 1px solid #a2a09d !important;
}
.v-btn {
  margin: 0px !important; // Remove default button margin
}
</style>
